import { Component, createRef } from 'react'
import withRouter from '../components/withRouter'
import { GoogleMap, LoadScript, InfoWindow, Marker } from '@react-google-maps/api'
import TopMenu from '../components/topMenu'
import BottomMenu from '../components/bottomMenu'
import MiniWide from '../components/miniWide'
import Card from '../components/card'
import SmallCard from '../components/smallCard'
import { FaRecordVinyl, FaStar, FaRegWindowClose } from 'react-icons/fa'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa6'
import { GiMicrophone, GiGuitar } from 'react-icons/gi'
import { CiBeerMugFull } from 'react-icons/ci'
import { MdDining, MdOutlineQuestionAnswer } from 'react-icons/md'
import { BiReset } from 'react-icons/bi'
import { BsFire } from 'react-icons/bs'
import { TbFilterSearch } from 'react-icons/tb'
import { API, Auth } from 'aws-amplify'
import moment from 'moment'
import Beer from '../images/beer.png'
import Food from '../images/food.png'
import Mic from '../images/mic-p.png'
import Crowd from '../images/crowd-p.png'
import Venue from '../images/venue.png'
import Comedy from '../images/comedy-p.png'
import ComedyClub from '../images/comedy.png'
import Music from '../images/music-p.png'
import Church from '../images/chruch.png'
import Club from '../images/club.png'
import DJ from '../images/dj-p.png'
import Party from '../images/party-watch-party.png'
import Tasting from '../images/tasting.png'
import Crafts from '../images/arts-crafts.png'
import Booth from '../images/booth.png'
import Bounce from '../images/bounce_house.png'
import Paint from '../images/paint.png'
import Performer from '../images/performer.png'
import ABNB from '../images/airbnb.png'
import Booking from '../images/booking.png'
import Cafe from '../images/cafe.png'
import Hotels from '../helpers/hotels.json'
import Bingo from '../images/bingo.png'
import Cards from '../images/poker.png'
import Boating from '../images/boating-icon.png'
import Bookstore from '../images/bookstore-icon.png'
import Bowling from '../images/bowling-icon.png'
import Golf from '../images/golf-icon.png'
import './fan.css'
import './node.css'

const timeout = 90000

class Fan extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: true,
            lastSearch: { dist: 25 },
            loc: '',
            lastLoc: '',
            locIsGood: false,
            dist: 25,
            center: null,
            options: null,
            month: moment().date(1).format('YYYY-MM-DD'),
            days: [moment().date()],
            start: moment().format('YYYY-MM-DD'),
            end: moment().add(1, 'day').format('YYYY-MM-DD'),
            pref: null,
            topic: null,
            searchChanged: false,
            mapsize: 'half',
            view: 'map',
            menu: {
                left: 'account',
                right: 'list',
                giglit: 'red',
                mode: 'fan'
            },
            filteredData: null,
            event: null,
            venue: null,
            zoom: 10,
            displaySettings: false,
            displaySearch: false,
            next: null,
            hotel: false,
            abnb: false,
            rentals: null,
            hotels: null,
            lodging: null,
            lastAbnbs: null,
            lastHotels: null,
            hiring: false,
            msg: '',
            displayMsg: false,
            displayLink: false,
            tid: null,
            src: null
        }
        this.handleLocationCheck = this.handleLocationCheck.bind(this)
        this.handleLocChanged = this.handleLocChanged.bind(this)
        this.handleDistChanged = this.handleDistChanged.bind(this)
        this.handleOnNotificationsSelect = this.handleOnNotificationsSelect.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
        this.handleOnPrefSelect = this.handleOnPrefSelect.bind(this)
        this.handleModeChange = this.handleModeChange.bind(this)
        this.handleDayChanged = this.handleDayChanged.bind(this)
        this.handleMonthChanged = this.handleMonthChanged.bind(this)
        this.handleMonthSelected = this.handleMonthSelected.bind(this)
        this.handleOptionSelect = this.handleOptionSelect.bind(this)
        this.handleGetMyLoc = this.handleGetMyLoc.bind(this)
        this.handleFollow = this.handleFollow.bind(this)
        this.handleInterest = this.handleInterest.bind(this)
        this.handleAttending = this.handleAttending.bind(this)
        this.handleLeftMenu = this.handleLeftMenu.bind(this)
        this.handleRightMenu = this.handleRightMenu.bind(this)
        this.handleGiglit = this.handleGiglit.bind(this)
        this.handleGoToCard = this.handleGoToCard.bind(this)
        this.handleDisplaySettings = this.handleDisplaySettings.bind(this)
        this.handleDisplaySearch = this.handleDisplaySearch.bind(this)
        this.handleResetOptions = this.handleResetOptions.bind(this)
        this.handleAbnb = this.handleAbnb.bind(this)
        this.handleHotels = this.handleHotels.bind(this)
        this.handleHiring = this.handleHiring.bind(this)
    }

    FanCards = createRef()

    async componentDidMount() {
        this.props.setMode('fan')
        if (this.props.concierge && this.props.isAuthenticated) {
            try {
                this.props.setUser(null)
                this.props.userHasAuthenticated(false)
                await Auth.signOut({ global: true })
            } catch (e) {
                console.log(e.message)
            }
        }
        if (this.props.isAuthenticated && this.props.user && this.props.user.active && this.props.user.dyk && this.props.user.dyk.fan) {
            this.setState({ isLoading: false })
            this.handleDYK()
        } else {
            const { search } = this.props
            const queryParams = new URLSearchParams(search.search)
            const refresh = queryParams.get('refresh') || false
            const addr = queryParams.get('addr') || null
            if (!this.props.data || refresh || addr) {
                if (addr) {
                    this.setState({ dist: 10 })
                    this.handleLocationCheck(addr)
                } else if (this.props.myloc) {
                    this.setState({ center: this.props.myLoc, dist: this.props.user && this.props.user.dist ? this.props.user.dist : this.state.dist, locIsGood: true })
                    this.getData(this.props.myLoc, this.props.user && this.props.user.dist ? this.props.user.dist : this.state.dist)
                } else {
                    const gl = navigator.geolocation
                    gl.getCurrentPosition(position => {
                        this.props.onMyLoc({ lat: position.coords.latitude, lng: position.coords.longitude })
                        this.setState({ center: { lat: position.coords.latitude, lng: position.coords.longitude }, isMounting: false, dist: this.props.user && this.props.user.dist ? this.props.user.dist : this.state.dist, locIsGood: true })
                        this.getData({ lat: position.coords.latitude, lng: position.coords.longitude }, this.props.user && this.props.user.dist ? this.props.user.dist : this.state.dist)
                    }, err => {
                        if (this.props.user && this.props.user.defaultLoc) {
                            this.props.onMyLoc(this.props.user.defaultLoc)
                            this.setState({ center: this.props.user.defaultLoc, dist: this.props.user.dist || this.state.dist, locIsGood: true })
                            this.getData(this.props.user.defaultLoc, this.props.user.dist || this.state.dist)
                        } else this.setState({ isLoading: false })
                    })
                }
            } else {
                if (this.props.filter) {
                    this.setState({
                        center: this.props.myLoc,
                        loc: this.props.filter.loc || '',
                        dist: this.props.filter.dist || (this.props.user && this.props.user.dist ? this.props.user.dist : this.state.dist),
                        start: this.props.filter.start || null,
                        end: this.props.filter.end || null,
                        days: this.props.filter.days || [],
                        pref: this.props.filter.pref || null,
                        locIsGood: true
                    })
                } else {
                    this.setState({ center: this.props.myLoc, dist: this.props.user && this.props.user.dist ? this.props.user.dist : this.state.dist, locIsGood: true })
                }
                this.handleFilter(null, this.props.filter ? (this.props.filter.pref || null) : this.state.pref)
            }
        }
    }

    handleReset() {
        const { search } = this.props
        const queryParams = new URLSearchParams(search.search)
        const addr = queryParams.get('addr') || null
        this.setState({
            month: moment().date(1).format('YYYY-MM-DD'),
            days: [moment().date()],
            start: moment().format('YYYY-MM-DD'),
            end: moment().add(1, 'day').format('YYYY-MM-DD'),
            displayMsg: false,
            dist: 10,
            displayLink: false,
            tid: null,
            event: null,
            venue: null,
            mapsize: 'half',
            view: 'map',
            zoom: 10,
            displaySearch: false
        })
        this.scrollToRef(this.FanCards)
        this.handleLocationCheck(addr)
    }

    handleDisplaySettings() {
        this.setState({ displaySearch: false, displaySettings: !this.state.displaySettings })
    }

    handleDisplaySearch() {
        if (this.props.concierge) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleReset(), timeout)
            this.setState({ tid })
        }
        if (this.state.displaySearch) {
            this.handleSearch()
            this.setState({ displaySettings: false, displaySearch: false, topic: null, menu: { ...this.state.menu, mode: 'fan' } })
        } else {
            if (!this.state.options && this.props.isAuthenticated) {
                API.get('lt', 'options?prop=node')
                    .then(resp => this.setState({ options: resp.data || [] }))
                    .catch(err => {
                        console.log(err)
                        if (err.response && err.response.status && err.response.status === 403) this.handleNavigate('main')
                    })
            }
            this.setState({ displaySettings: false, displaySearch: true, topic: null, menu: { ...this.state.menu, mode: null } })
        }
    }

    handleGetMyLoc() {
        const gl = navigator.geolocation
        gl.getCurrentPosition(position => {
            API.get('lt', `geo?coord=${position.coords.latitude},${position.coords.longitude}`, { headers: { Authorization: `Basic VSQzcm5hbWU6UGEkc3dvcmQ=` } })
                .then(resp => {
                    if (resp.data && resp.data.results[0]) {
                        const loc = resp.data.results[0].formatted_address
                        this.props.onMyLoc(resp.data.results[0].geometry.location)
                        this.setState({ loc, locIsGood: true, lastLoc: loc, center: resp.data.results[0].geometry.location, searchChanged: true, locChanged: true })
                    } else {
                        this.setState({ locIsGood: false, loc: 'Not Found' })
                    }
                })
        }, err => {
            console.log(err)
            this.setState({ locIsGood: false, loc: 'Not Found' })
        })
    }

    handleLocationCheck(addr) {
        if ((this.state.loc && this.state.loc !== this.state.lastLoc) || addr) {
            API.get('lt', `geo?address=${addr ? addr.replace(/#/g, '%23') : this.state.loc.replace(/#/g, '%23')}`, { headers: { Authorization: `Basic VSQzcm5hbWU6UGEkc3dvcmQ=` } })
                .then(resp => {
                    if (resp.data && resp.data.results[0]) {
                        const loc = resp.data.results[0].formatted_address
                        this.props.onMyLoc(resp.data.results[0].geometry.location)
                        this.setState({ loc, locIsGood: true, lastLoc: loc, center: resp.data.results[0].geometry.location, searchChanged: true, hotel: false, abnb: false })
                        if (addr) this.getData()
                    }
                })
                .catch(e => {
                    this.setState({ loc: '', locIsGood: false, hotel: false, abnb: false })
                })
        }
    }

    handleDistChanged(event) {
        if (this.props.concierge) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleReset(), timeout)
            this.setState({ tid })
        }
        let dist = event.target.value === "0" ? "1" : (event.target.value)
        this.setState({ dist })
    }

    handleLocChanged(event) {
        this.setState({ locIsGood: false, loc: event.target.value.replace(/[^a-zA-Z0-9-, ]/g, "") })
    }

    handleSearch() {
        if (this.props.concierge) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleReset(), timeout)
            this.setState({ tid })
        }
        let doIt = false
        let lodging = false
        if (this.state.lastSearch) {
            if (this.state.lastSearch.dist && this.state.lastSearch.dist !== this.state.dist) {
                doIt = true
            } else {
                if (this.state.searchChanged) {
                    doIt = true
                } else if (!this.state.lastSearch.start ||
                    !this.state.lastSearch.end ||
                    !this.state.start ||
                    !this.state.end ||
                    moment(this.state.start).isBefore(moment(this.state.lastSearch.start)) ||
                    moment(this.state.end).isAfter(moment(this.state.lastSearch.end))) {
                    doIt = true
                }
            }
            if (doIt) {
                this.handleCloseMarker()
                this.props.setFilter({
                    loc: this.state.loc,
                    dist: this.state.dist,
                    start: this.state.start,
                    end: this.state.end,
                    days: this.state.days,
                    pref: this.state.pref
                })
                this.getData()
            } else this.handleFilter()
            if (this.state.abnb || this.state.hotel) {
                if (this.state.searchChanged) {
                    this.handleLodging(this.state.abnb ? 'abnb' : 'hotel')
                    lodging = true
                } else if (!this.state.lastSearch.start ||
                    !this.state.lastSearch.end ||
                    !this.state.start ||
                    !this.state.end ||
                    moment(this.state.start).isBefore(moment(this.state.lastSearch.start)) ||
                    moment(this.state.end).isAfter(moment(this.state.lastSearch.end))) {
                    this.handleLodging(this.state.abnb ? 'abnb' : 'hotel')
                    lodging = true
                } else {
                    if (this.state.abnb) {
                        this.setState({ rentals: this.state.lastAbnbs })
                    } else {
                        this.setState({ hotels: this.state.lastHotels })
                    }
                }
            }
        } else {
            this.getData()
            if (this.state.abnb || this.state.hotel) {
                this.handleLodging(this.state.abnb ? 'abnb' : 'hotel')
                lodging = true
            }
        }
        if ((this.state.abnb || this.state.hotel) && !lodging) {
            if (this.state.abnb && !this.state.rentals && !this.state.lastAbnbs) {
                this.handleLodging('abnb')
            } else if (this.state.hotel && !this.state.hotels && !this.state.lastHotels) {
                this.handleLodging('hotel')
            }
        }
    }

    handleOptionSelect(node, cat) {
        if (node === 'amenities') {
            let amenities = this.state.pref && this.state.pref.amenities ? this.state.pref.amenities : []
            let idx = amenities.indexOf(cat)
            if (idx > -1) {
                amenities.splice(idx, 1)
            } else amenities.push(cat)
            this.setState({ pref: { ...this.state.pref, amenities } })
        } else {
            if (this.state.pref && this.state.pref[node]) {
                let cats = [...this.state.pref[node]]
                let idx = cats.indexOf(cat)
                if (idx === -1) {
                    cats.push(cat)
                } else cats.splice(idx, 1)
                this.setState({ pref: { ...this.state.pref, [node]: cats } })
            } else {
                if (this.state.pref && this.state.pref.amenities) {
                    this.setState({ pref: { amenities: this.state.pref.amenities, [node]: [cat] } })
                } else this.setState({ pref: { [node]: [cat] } })
            }
        }
    }

    handleResetOptions() {
        this.setState({ pref: null })
    }

    handleFilter(d, p) {
        const pref = p || this.state.pref
        const amenities = pref ? pref['amenities'] : null
        const idx = pref ? Object.keys(pref).findIndex(p => p !== 'amenities') : -1
        const node = idx > -1 ? Object.keys(pref)[idx] : null
        const categories = idx > -1 ? Object.values(pref)[idx] : null
        let end = this.props.filter ? this.props.filter.end : this.state.end
        let start = this.props.filter ? this.props.filter.start : this.state.start
        let dist = this.props.filter && this.props.filter.dist ? this.props.filter.dist : this.state.dist
        if (d || this.props.data) {
            this.setState({ isLoading: true })
            let data = d || JSON.parse(JSON.stringify(this.props.data))
            let filteredData = { events: [], venues: [] }
            data.filter(d => d.nodetype === 'Venue').forEach(v => {
                let vkeep = null
                if (v.events) {
                    if (!pref || !pref['Venue']) {
                        v.events && v.events.filter(e => (!end || moment(e.startTime).isBefore(moment(end))) &&
                            (!start || moment(e.stopTime).isAfter(moment(start)))).sort((a, b) => {
                                if (moment(a.startTime).isBefore(moment(b.startTime))) return -1
                                if (moment(a.startTime).isAfter(moment(b.startTime))) return 1
                                return 0
                            }).forEach(e => {
                                let keep = true
                                if (amenities) {
                                    amenities.forEach(a => {
                                        if (!e.amenities || e.amenities.indexOf(a) === -1) keep = false
                                    })
                                }
                                if (keep) {
                                    if (node) {
                                        keep = e.searchSlots && e.searchSlots.filter(s => s.node === node && pref[node].indexOf(s.category) > -1).length > 0
                                        if (!keep && categories && e.summary && categories.indexOf(e.summary) > -1) keep = true
                                    }
                                }
                                if (keep) {
                                    filteredData.events.push(e)
                                    if (!vkeep) {
                                        vkeep = [v.id]
                                    } else if (vkeep.indexOf(v.id) === -1) vkeep.push(v.id)
                                }
                            })
                    }
                }
                if (!node || (node === 'Venue' && pref[node].indexOf(v.category) > -1)) {
                    let keep = true
                    if (amenities) {
                        amenities.forEach(a => {
                            if (!v.amenities || v.amenities.indexOf(a) === -1) keep = false
                        })
                    }
                    if (keep) {
                        filteredData.venues.push(v)
                    }
                } else if (node && node !== 'Venue') {
                    if (vkeep) data.filter(d => d.nodetype === 'Venue').forEach(v => {
                        if (vkeep.indexOf(v.id) > -1) {
                            filteredData.venues.push(v)
                        }
                    })
                } else {
                    //console.log('keep 3', v)
                    //filteredData.venues.push(v)
                }
            })
            filteredData.venues.sort((a, b) => {
                if ((a.distance || dist) > (b.distance || dist)) return 1
                if ((a.distance || dist) < (b.distance || dist)) return -1
                return 0
            })
            filteredData.events.sort((a, b) => {
                if ((a.distance || dist) > (b.distance || dist)) return 1
                if ((a.distance || dist) < (b.distance || dist)) return -1
                return 0
            })
            this.setState({ filteredData, isLoading: false })
        }
    }

    handleHotTopic() {
        if (this.props.concierge) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleReset(), timeout)
            this.setState({ tid })
        }
        let filteredData = { events: [], venues: [] }
        if (this.props.data) {
            this.setState({ isLoading: true })
            this.props.data.filter(d => d.nodetype === 'Venue').forEach(v => {
                if (v.events && v.events.length > 0) {
                    v.events.forEach(e => {
                        if (e.interested || e.attending) {
                            if (filteredData.events[0]) {
                                if (((e.interested || 0) + (e.attending || 0)) > ((filteredData.events[0].interested || 0) + (filteredData.events[0].attending || 0))) {
                                    filteredData = { events: [v.events[0]], venues: [v] }
                                }
                            } else {
                                filteredData = { events: [v.events[0]], venues: [v] }
                            }
                        }
                    })
                }
            })
        }
        this.setState({ filteredData, isLoading: false })
    }

    handleHotTopics(topic) {
        if (this.props.concierge) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleReset(), timeout)
            this.setState({ tid })
        }
        let pref = null
        switch (topic) {
            case 'restaurant':
                pref = { 'Venue': ['Restaurant'], amenities: null }
                break
            case 'bar':
                pref = { 'Venue': ['Bar', 'Nightclub'], amenities: ['Beer'] }
                break
            case 'dj':
                pref = { 'Entertainment': ['DJ'], amenities: null }
                break
            case 'karaoke':
                pref = { 'Entertainment': ['Karaoke'], amenities: null }
                break
            case 'music':
                pref = { 'Entertainment': ['Acoustic Band', 'Band', 'Solo Artist', 'Tribute Band', 'Group', 'Duet'], amenities: null }
                break
            case 'trivia':
                pref = { 'Entertainment': ['Trivia'], amenities: null }
                break
            default:
                pref = {}
        }
        this.setState({ pref, topic, event: null, venue: null, menu: { ...this.state.menu, right: 'list' }, zoom: 10 })
        this.props.setFilter({
            loc: this.state.loc,
            dist: this.state.dist,
            start: this.state.start,
            end: this.state.end,
            days: this.state.days,
            pref
        })
        if (topic === 'fire') {
            this.handleHotTopic()
        } else { this.handleFilter(null, pref) }
    }

    handleModeChange(mode) {
        if (mode && !this.props.concierge) {
            this.props.setMode(mode)
            if (mode === 'contactus' || mode === 'dyks') {
                this.handleNavigate(mode)
            } else if (mode === 'tix') {
                this.handleNavigate('tixcheck')
            } else {
                if (mode !== 'fan') {
                    this.handleNavigate(`my/${mode}s`)
                }
            }
        }
        this.setState({ displaySettings: false })
    }

    handleOnNotificationsSelect() {
        this.handleNavigate('notifications')
    }

    handleOnPrefSelect() {
        this.handleNavigate('profile')
    }

    handleMonthChanged(dir) {
        if (this.props.concierge) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleReset(), timeout)
            this.setState({ tid })
        }
        let month = moment(this.state.month)
        let days = []
        if (dir === 'back') {
            month.subtract(1, 'month')
        } else if (dir === 'next') {
            month.add(1, 'month')
        }
        let start = this.state.start ? moment(this.state.start) : null
        let end = this.state.end ? moment(this.state.end) : null
        if (start && end) {
            if (end.isBefore(month) || start.isAfter(moment(month).add(1, 'month'))) {
                days = []
            } else if (start.isBefore(month)) {
                if (end.isAfter(moment(month).add(1, 'month'))) {
                    for (let d = 1; d <= moment(month).add(1, 'month').subtract(1, 'day').date(); d++) {
                        days.push(d)
                    }
                } else if (end.isBetween(month, moment(month).add(1, 'month'))) {
                    for (let d = 1; d < end.date(); d++) {
                        days.push(d)
                    }
                }
            } else if (start.isSame(month) || start.isBetween(month, moment(month).add(1, 'month'))) {
                if (end.isAfter(moment(month).add(1, 'month'))) {
                    for (let d = start.date(); d <= moment(month).add(1, 'month').subtract(1, 'day').date(); d++) {
                        days.push(d)
                    }
                } else {
                    for (let d = start.date(); d < end.date(); d++) {
                        days.push(d)
                    }
                }
            }
        } else console.log('no days')
        this.setState({ days, month: month.format('YYYY-MM-DD'), start: start ? start.format('YYYY-MM-DD') : null, end: end ? end.format('YYYY-MM-DD') : null })
    }

    handleMonthSelected() {
        this.setState({ days: [], start: null, end: null })
        if (this.props.concierge) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleReset(), timeout)
            this.setState({ tid })
        }
    }

    handleDayChanged(day) {
        if (this.props.concierge) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleReset(), timeout)
            this.setState({ tid })
        }
        if (this.state.start) {
            let month = moment(this.state.month)
            let sel = moment(this.state.month).date(day)
            let start = moment(this.state.start)
            let end = moment(this.state.end)
            let days = []
            if (sel.isBefore(end)) {
                start = sel
            } else {
                end = moment(sel).add(1, 'day')
            }
            if (start.isBefore(month)) {
                if (end.isAfter(moment(month).add(1, 'month'))) {
                    for (let d = 1; d <= moment(month).add(1, 'month').subtract(1, 'day').date(); d++) {
                        days.push(d)
                    }
                } else if (end.isBetween(month, moment(month).add(1, 'month'))) {
                    for (let d = 1; d < end.date(); d++) {
                        days.push(d)
                    }
                }
            } else if (start.isSame(month) || start.isBetween(month, moment(month).add(1, 'month'))) {
                if (end.isSame(moment(month).add(1, 'month')) || end.isAfter(moment(month).add(1, 'month'))) {
                    for (let d = start.date(); d <= moment(month).add(1, 'month').subtract(1, 'day').date(); d++) {
                        days.push(d)
                    }
                } else {
                    for (let d = start.date(); d < end.date(); d++) {
                        days.push(d)
                    }
                }
            }
            this.setState({ days, start: start.format('YYYY-MM-DD'), end: end.format('YYYY-MM-DD'), searchChanged: true })
        } else this.setState({ start: moment(this.state.month).date(day).format('YYYY-MM-DD'), end: moment(this.state.month).date(day).add(1, 'day').format('YYYY-MM-DD'), days: [day], searchChanged: true })
    }

    handleSwipeClick() {
        if (this.props.concierge) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleReset(), timeout)
            this.setState({ tid })
        }
        this.setState({ mapsize: this.state.mapsize === 'full' ? 'half' : 'full', event: null, venue: null, menu: { ...this.state.menu, right: 'list' } })
    }

    handleEventSelected(eid) {
        if (eid) {
            if (this.props.concierge) {
                if (this.state.tid) clearTimeout(this.state.tid)
                let tid = setTimeout(() => this.handleReset(), timeout)
                this.setState({ tid })
            }
            const headers = this.props.user && this.props.user.active ? null : { headers: { Authorization: `Basic VSQzcm5hbWU6UGEkc3dvcmQ=` } }
            API.get('lt', `${this.props.user && this.props.user.active ? 'fan' : ''}event/${eid}${this.props.myLoc ? `?lat=${this.props.myLoc.lat}&lng=${this.props.myLoc.lng}` : ''}`, headers)
                .then(resp => {
                    this.setState({ event: resp.data, venue: null, mapsize: 'half', menu: { ...this.state.menu, right: 'map' }, center: resp.data.address && resp.data.address.coord ? resp.data.address.coord : this.state.center, zoom: resp.data.address && resp.data.address.coord ? 15 : 10 })
                    this.scrollToRef(this.FanCards)
                })
                .catch(err => {
                    console.log(err)
                    if (err.response && err.response.status && err.response.status === 403) this.handleNavigate('main')
                })
        }
    }

    handleAttending(id) {
        if (this.state.event && !this.props.concierge) {
            if (this.props.isAuthenticated) {
                API.put('lt', `interest/${id}`, { body: { status: 'attending', local: moment().format('YYYY-MM-DD HH:mm') } })
                    .then(resp => {
                        let idx = this.props.data.findIndex(d => d.id === this.state.event.id)
                        if (idx > -1) {
                            let event = this.state.event //Object.assign({}, { ...this.state.event, events: [Object.assign({}, { ...this.state.event.events[0], iaminterested: false, iamattending: this.state.event.events[0].iamattending ? false : true, attending: this.state.event.events[0].iamattending ? this.state.event.events[0].attending - 1 : ((this.state.event.events[0].attending || 0) + 1), interested: this.state.event.events[0].iaminterested ? this.state.event.events[0].interested - 1 : (this.state.event.events[0].interested || 0) })] })
                            const iamattending = !(event.events[0].iamattending || false)
                            if (event.events[0].iaminterested) event.events[0].interested -= 1
                            event.events[0].iaminterested = false
                            event.events[0].iamattending = iamattending
                            event.events[0].attending = iamattending ? (event.events[0].attending || 0) + 1 : (event.events[0].attending - 1)


                            //let newVenue = Object.assign({}, { ...this.props.data[idx], events: [...this.props.data[idx].events.splice(0, eidx), { ...this.props.data[idx].events[eidx], iaminterested: false, iamattending: !iamattending, attending: iamattending ? this.props.data[idx].events[eidx].attending - 1 : ((this.props.data[idx].events[eidx].attending || 0) + 1), interested: iaminterested ? this.props.data[idx].events[eidx].interested - 1 : (this.props.data[idx].events[eidx].interested || 0) }, ...this.props.data[idx].events.splice(eidx + 1)] })
                            //this.props.setData([...this.props.data.slice(0, idx), newVenue, ...this.props.data.slice(idx + 1)])
                            this.setState({ event })
                            let eidx = this.props.data[idx].events.findIndex(e => e.id === event.events[0].id)
                            if (eidx > -1) {
                                let data = this.props.data
                                data[idx].events[eidx] = event.events[0]
                                this.props.setData(data)
                            }
                            //this.handleFilter()
                            this.handleRefresh()
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        if (err.response && err.response.status && err.response.status === 403) {
                            this.handleNavigate('main')
                        } else this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true })
                    })
            } else {
                this.handleNavigate('main')
            }
        }
    }

    handleInterest() {
        if (this.state.event && !this.props.concierge) {
            if (this.props.isAuthenticated) {
                API.put('lt', `interest/${this.state.event.events[0].id}`, { body: { status: 'interested', local: moment().format('YYYY-MM-DD HH:mm') } })
                    .then(resp => {
                        let idx = this.props.data.findIndex(d => d.id === this.state.event.id)
                        if (idx > -1) {
                            //let event = Object.assign({}, { ...this.state.event, events: [Object.assign({}, { ...this.state.event.events[0], iamattending: false, iaminterested: this.state.event.events[0].iaminterested ? false : true, interested: this.state.event.events[0].iaminterested ? this.state.event.events[0].interested - 1 : ((this.state.event.events[0].interested || 0) + 1), attending: this.state.event.events[0].iamattending ? this.state.event.events[0].attending - 1 : (this.state.event.events[0].attending || 0) })] })
                            //console.log(idx, eidx, this.state.event, this.props.data[idx].events[eidx])
                            //const iamattending = this.props.data[idx].events[eidx].iamattending || false
                            //const iaminterested = this.props.data[idx].events[eidx].iaminterested || false
                            //console.log(idx, eidx, this.state.event, this.props.data[idx].events[eidx], iamattending, iaminterested)
                            //let newVenue = Object.assign({}, { ...this.props.data[idx], events: [...this.props.data[idx].events.splice(0, eidx), { ...this.props.data[idx].events[eidx], iamattending: false, iaminterested: !iaminterested, interested: this.props.data[idx].events[eidx].iaminterested ? this.props.data[idx].events[eidx].interested - 1 : ((this.props.data[idx].events[eidx].interested || 0) + 1), attending: iamattending ? this.props.data[idx].events[eidx].attending - 1 : (this.props.data[idx].events[eidx].attending || 0) }, ...this.props.data[idx].events.splice(eidx + 1)] })
                            //this.props.setData([...this.props.data.slice(0, idx), newVenue, ...this.props.data.slice(idx + 1)])
                            let event = this.state.event
                            const iaminterested = !(event.events[0].iaminterested || false)
                            if (event.events[0].iamattending) event.events[0].attending -= 1
                            event.events[0].iamattending = false
                            event.events[0].iaminterested = iaminterested
                            event.events[0].interested = iaminterested ? (event.events[0].interested || 0) + 1 : (event.events[0].interested - 1)
                            this.setState({ event })
                            let eidx = this.props.data[idx].events.findIndex(e => e.id === event.events[0].id)
                            if (eidx > -1) {
                                let data = this.props.data
                                data[idx].events[eidx] = event.events[0]
                                this.props.setData(data)
                            }
                            //this.handleFilter()
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        if (err.response && err.response.status && err.response.status === 403) {
                            this.handleNavigate('main')
                        } else this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true })
                    })
            } else {
                this.handleNavigate('main')
            }
        }
    }

    handleVenueSelected(v) {
        if (this.props.concierge) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleReset(), timeout)
            this.setState({ tid })
        }
        this.setState({ venue: v, event: null, mapsize: 'half', menu: { ...this.state.menu, right: 'map' }, center: v.address.coord, zoom: 15 })
        this.scrollToRef(this.FanCards)
    }

    handleSmallSelected(type) {
        if (this.props.concierge) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleReset(), timeout)
            this.setState({ tid })
        }
        if (type === 'venue') {
            this.setState({ event: null, mapsize: 'half', menu: { ...this.state.menu, right: 'map' }, center: this.state.venue.address.coord })
        } else if (type === 'event') {
            this.setState({ venue: null, mapsize: 'half', menu: { ...this.state.menu, right: 'map' }, center: this.state.event.address.coord })
        } else if (type === 'hotel') {
            if (this.state.lodging.url) window.open(this.state.lodging.url, '_blank', 'noopener')
        }

    }

    handleCloseMarker() {
        if (this.props.concierge) {
            if (this.state.tid) clearTimeout(this.state.tid)
            let tid = setTimeout(() => this.handleReset(), timeout)
            this.setState({ tid })
        }
        this.setState({ event: null, venue: null, lodging: null })
    }

    handleFollow(id) {
        if (this.state.venue && !this.props.concierge) {
            if (this.props.isAuthenticated) {
                API.put('lt', `interest/${this.state.venue.id}`, { body: { status: 'following' } })
                    .then(resp => {
                        let idx = this.props.data.findIndex(d => d.id === this.state.venue.id)
                        if (idx > -1) {
                            let newVenue = { ...this.props.data[idx], iamfollowing: this.props.data[idx].iamfollowing ? !this.props.data[idx].iamfollowing : true, followers: this.props.data[idx].iamfollowing ? this.props.data[idx].followers - 1 : this.props.data[idx].followers + 1 }
                            this.props.setData([...this.props.data.slice(0, idx), newVenue, ...this.props.data.slice(idx + 1)])
                            this.setState({ venue: { ...this.state.venue, iamfollowing: this.state.venue.iamfollowing ? !this.state.venue.iamfollowing : true, followers: this.state.venue.iamfollowing ? this.state.venue.followers - 1 : ((this.state.venue.followers || 0) + 1) } })
                            this.handleFilter()
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        if (err.response && err.response.status && err.response.status === 403) this.handleNavigate('main')
                    })
            } else {
                this.handleNavigate('main')
            }
        }
    }

    handleLeftMenu() {
        this.handleNavigate('main')
    }

    handleGiglit() {
        this.giglit()
    }

    handleRightMenu() {
        if (this.state.menu.right === 'list') {
            this.setState({ event: null, venue: null })
            this.handleNavigate('list')
        } else {
            this.setState({
                event: null,
                venue: null,
                menu: { ...this.state.menu, right: (this.state.event || this.state.venue) ? 'list' : 'map' },
                zoom: 10
            })
        }
    }

    handleGoToCard() {
        if (this.state.event) {
            if (this.props.concierge) {
                if (this.state.tid) clearTimeout(this.state.tid)
                let tid = setTimeout(() => this.handleReset(), timeout)
                this.setState({ displayLink: true, src: `https://gigloca.com/event/${this.state.event.events[0].id}`, title: this.state.event.events[0].title, tid })
            } else this.handleNavigate(`event/${this.state.event.events[0].id}`)
        } else if (this.state.venue) {
            if (this.props.concierge) {
                if (this.state.tid) clearTimeout(this.state.tid)
                let tid = setTimeout(() => this.handleReset(), timeout)
                this.setState({ displayLink: true, src: `https://gigloca.com/venue/${this.state.venue.id}`, title: this.state.venue.name, tid })
            } else this.handleNavigate(`venue/${this.state.venue.id}`)
        } else return false
    }

    handleNavigate(page) {
        if (!this.state.isLoading) {
            this.props.onAddHistory('/')
            const { navigate } = this.props
            navigate(`/${page}`)
        }
    }

    handleVPinSelected(pin) {
        this.setState({
            venue: pin,
            event: null,
            lodging: null,
            center: pin && pin.address && pin.address.coord ? pin.address.coord : this.state.center,
            menu: { ...this.state.menu, right: pin ? 'map' : 'list' }
        })
    }

    handleEPinSelected(pin) {
        console.log(pin)
        this.setState({
            venue: pin,
            event: pin,
            lodging: null,
            center: pin && pin.address && pin.address.coord ? pin.address.coord : this.state.center,
            menu: { ...this.state.menu, right: pin ? 'map' : 'list' }
        })
    }

    handleHPinSelected(pin) {
        this.setState({
            venue: null,
            event: null,
            lodging: pin,
            center: pin && pin.coord ? pin.coord : this.state.center,
            menu: { ...this.state.menu, right: pin ? 'map' : 'list' }
        })
    }

    handleIframeClick() {
        if (this.state.tid) clearTimeout(this.state.tid)
        let tid = setTimeout(() => this.handleReset(), timeout)
        this.setState({ displayLink: false, src: null, title: null, tid })
    }

    handleDYK() {
        setTimeout(() => this.handleNavigate(`DYK`, true), 150)
    }

    handleAbnb() {
        if (this.props.user && this.props.user.fanSubscription) {
            if (!this.state.abnb) {
                this.setState({ abnb: true })
            }
            else this.setState({ abnb: false, rentals: null, lastAbnbs: this.state.rentals || this.state.lastHotels })
        } else this.setState({ msg: '"Find AB&B" requires is a Subscription Service. You may subscribe in your Profile.' })
    }

    handleHotels() {
        if (this.props.user && this.props.user.fanSubscription) {
            if (!this.state.hotel) {
                this.setState({ hotel: true })
            }
            else this.setState({ hotel: false, hotels: null, lastHotels: this.state.hotels || this.state.lastHotels })
        } else this.setState({ msg: '"Find Hotels" requires a subscription to use. You may subscribe in your Profile.' })
    }

    handleLodging(type) {
        //console.log('handle lodging')
        if (this.props.user && this.props.user.fanSubscription && type === 'hotel') setTimeout(() => this.setState({ hotels: Hotels.hotels, lastHotels: this.state.hotels || this.state.lastHotels, rentals: [], lastAbnbs: this.state.rentals || this.state.lastAbnbs }), 1500)
        /* return false
        if (this.props.user && this.props.user.fanSubscription && (this.state.abnb || this.state.hotels)) {
            if (this.props.myLoc) {
                let qry = `lat=${this.props.myLoc.lat}&lng=${this.props.myLoc.lng}&dist=${this.state.dist}`
                if (this.state.start && this.state.end) {
                    qry += `&start=${this.state.start}&end=${this.state.end}`
                    qry += `&${this.state.abnb ? 'abnb=true' : 'hotels=true'}`
                    if (this.state.next) qry += `&next=${this.state.next}`
                    const headers = this.props.isAuthenticated ? null : { headers: { Authorization: `Basic VSQzcm5hbWU6UGEkc3dvcmQ=` } }
                    API.get('lt', `fanstuff?${qry}`, headers)
                        .then(resp => {
                            //if (resp.hotels) this.setState({ hotels: resp.hotels })
                            //if (resp.rentals) this.setState({ rentals: resp.rentals })
                            //remove this when done testing
                            //if (this.props.user && this.props.user.fanSubscription && this.state.hotel) this.setState({ hotels: Hotels.hotels })
                            //this.setState({ abnb: false, hotels: false }) //, nextLodging: resp.data.next || null 

                        })
                        .catch(err => {
                            console.log(err)
                            this.setState({ isLoading: false, next: null })
                            if (err.response && err.response.status && err.response.status === 403) this.handleNavigate('main')
                        })
                } else {
                    //add a message about selecting a date range
                }
            } else {
                //add a message about selecting a location
            }
        } else this.setState({ abnb: false, hotels: false }) //add a message here about premium account
         */
    }

    handleHiring() {
        this.props.setHiring(!this.props.hiring)
    }

    handleMsgOK() {
        this.setState({ msg: '', displayMsg: false })
    }

    handleAbout() {
        window.open(`${window.location.origin}/about.html`, '_blank', 'noopener')
    }

    handleRefresh() {
        API.get('lt', 'user')
            .then(resp => this.props.setUser(resp.data))
            .catch(err => console.log(err))
    }

    async giglit() {
        if (this.state.filteredData) {
            let cnt = this.state.filteredData.events.length + this.state.filteredData.venues.length
            if (cnt > 1) {
                if (cnt > 35) cnt = 35
                let int = (Math.floor(Math.random() * cnt) + (cnt / 2.5)) * 300
                let nxt = 50
                let idx = Math.floor(Math.random() * cnt)
                let eid = null
                do {
                    int -= nxt
                    if (idx === cnt - 1) {
                        idx = 0
                    } else idx += 1
                    if (idx >= this.state.filteredData.events.length) {
                        eid = null
                        this.setState({
                            mapsize: 'half',
                            event: null,
                            venue: this.state.filteredData.venues[idx - this.state.filteredData.events.length],
                            center: this.state.filteredData.venues[idx - this.state.filteredData.events.length].address && this.state.filteredData.venues[idx - this.state.filteredData.events.length].address.coord ? this.state.filteredData.venues[idx - this.state.filteredData.events.length].address.coord : this.props.myLoc,
                            menu: { ...this.state.menu, right: 'map' }
                        })
                    } else if (this.state.filteredData.venues.length > 0) {
                        const tmp = idx
                        let vidx = this.state.filteredData.venues.findIndex(v => this.state.filteredData.events[tmp].venue === v.id)
                        let eidx = this.state.filteredData.venues[vidx].events.findIndex(e => e.id === this.state.filteredData.events[tmp].id)
                        eid = this.state.filteredData.events[tmp].id
                        this.setState({
                            mapsize: 'half',
                            venue: null,
                            event: Object.assign({}, { ...this.state.filteredData.venues[vidx], events: [{ ...this.state.filteredData.venues[vidx].events[eidx] }] }),
                            center: this.state.filteredData.events[idx].coord || this.props.myLoc
                        })
                    }
                    await this.spin(nxt += 50)
                } while (int > 0)
                if (this.props.concierge) {
                    if (this.state.tid) clearTimeout(this.state.tid)
                    let tid = setTimeout(() => this.handleReset(), timeout)
                    this.setState({ tid })
                }
                if (eid) this.handleEventSelected(eid)
            }
        }
    }

    spin = (int) => new Promise(resolve => {
        setTimeout(resolve, int);
    });

    getDist(coord1, coord2) {
        const R = 6371 * 0.621371; //(km to miles)
        const lat1 = coord1.lat;
        const lat2 = coord2.lat;
        const lon1 = coord1.lng;
        const lon2 = coord2.lng;
        const rLat1 = lat1 * Math.PI / 180; //lat1 in radians
        const rLat2 = lat2 * Math.PI / 180; //lat2 in radians
        const rLatDiff = (lat2 - lat1) * Math.PI / 180; //lat diff in radians
        const rLonDiff = (lon2 - lon1) * Math.PI / 180; //lon diff in radians

        const a = Math.sin(rLatDiff / 2) * Math.sin(rLatDiff / 2) + Math.cos(rLat1) * Math.cos(rLat2) * Math.sin(rLonDiff / 2) * Math.sin(rLonDiff / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    getMessage() {
        return <div className='Node-Confirm-Bottom'>
            <div className='Node-Row Confirm-Text'>{this.state.msg}</div>
            <div className="Node-Row Node-Flex-Wrap">
                <div className='Pref-Button Pref-Button-Save' onClick={() => this.handleMsgOK()}>OK</div>
            </div>
        </div>
    }

    getData(coord, dist) {
        if (coord || this.props.myLoc) {
            this.setState({ searchChanged: false, filteredData: null })
            let qry = `lat=${coord ? coord.lat : this.props.myLoc.lat}&lng=${coord ? coord.lng : this.props.myLoc.lng}&dist=${dist || this.state.dist}`
            if (this.state.start && this.state.end) {
                qry += `&start=${this.state.start}&end=${this.state.end}`
            } else qry += `&start=${moment().format('YYYY-MM-DD HH:mm')}`
            //uncomment below when ready to allow hotel and abnb lookup
            //if (this.props.user && this.props.user.fanSubscription && this.state.hotel) qry += `&hotels=true`
            //if (this.props.user && this.props.user.fanSubscription && this.state.abnb) qry += `&abnb=true`
            if (this.state.next) qry += `&next=${this.state.next}`

            // if (this.props.user && this.props.user.zone) {
            //     qry += `&zone=${this.props.user.zone}`
            // } else if (this.props.user && this.props.user.zip) qry += `&zip=${this.props.user.zip}`

            //qry += `&node=Activities&cat=Tasting`
            //if (this.state.node) qry += `&node=${this.state.node}`
            //if (this.state.cat && this.state.cat.length > 0) qry += `&cat=${this.state.cat.toString()}`
            //if (this.state.amenities && this.state.amenities.length > 0) qry += `&amenities=${this.state.amenities.toString()}`
            const headers = this.props.isAuthenticated ? null : { headers: { Authorization: `Basic VSQzcm5hbWU6UGEkc3dvcmQ=` } }
            API.get('lt', `${this.props.isAuthenticated ? 'fanstuff' : 'userstuff'}?${qry}`, headers)
                .then(resp => {
                    this.props.setData(resp.data || [])
                    if (resp.hotels) this.setState({ hotels: resp.hotels })
                    if (resp.rentals) this.setState({ rentals: resp.rentals })
                    //remove this when done testing
                    //if (this.props.user && this.props.user.fanSubscription && this.state.hotel) this.setState({ hotels: Hotels.hotels })
                    this.setState({ lastSearch: { start: this.state.start, end: this.state.end, dist: this.state.dist }, isLoading: false, next: resp.data.next || null })
                    this.handleFilter(resp.data || [])
                })
                .catch(err => {
                    console.log(err)
                    this.setState({ isLoading: false, next: null })
                    if (err.response && err.response.status && err.response.status === 403) this.handleNavigate('main')
                })
        }
    }

    getVenueMarker(category) {
        switch (category) {
            case 'Bar':
                return Beer
            case 'Church':
                return Church
            case 'Comedy Club':
                return ComedyClub
            case 'Nightclub':
                return Club
            case 'Restaurant':
                return Food
            case 'Cafe':
                return Cafe
            case 'Bookstore':
                return Bookstore
            case 'Water Tour':
                return Boating
            case 'Bowling':
                return Bowling
            case 'Golf':
                return Golf
            default:
                return Venue
        }
    }

    getEventMarker(summary) {
        if (summary.indexOf('Band') > -1) return Music
        switch (summary) {
            case 'Art':
                return Crafts
            case 'Bingo':
                return Bingo
            case 'Booth':
                return Booth
            case 'Bounce House':
                return Bounce
            case 'Cards':
                return Cards
            case 'Comedian':
                return Comedy
            case 'Crafting':
                return Crafts
            case 'DJ':
                return DJ
            case 'Duet':
                return Music
            case 'Group':
                return Music
            case 'Karaoke':
                return Mic
            case 'Paint':
                return Paint
            case 'Party':
                return Party
            case 'Performer':
                return Performer
            case 'Solo Artist':
                return Music
            case 'Tasting':
                return Tasting
            case 'Trivia':
                return Mic
            case 'Watch Party':
                return Party
            default:
                return Crowd
        }
    }

    getMarkers() {
        if (this.state.filteredData || this.state.hotels || this.state.abnb) {
            //clean this up!!!
            let markers = []
            if (this.state.filteredData) {
                this.state.filteredData.venues.filter(d => d.address && d.address.coord && this.state.filteredData.events.findIndex(e => e.venue === d.id) === -1).forEach((v, vidx) => {
                    markers.push(<Marker onClick={() => this.handleVPinSelected(v)} key={`vpin-${vidx}`}
                        position={v.address.coord}
                        animation={this.props.hiring && v.hiring ? 1 : 2}
                        title={v.name}
                        icon={{
                            url: this.getVenueMarker(v.category || ''),
                            scaledSize: { height: 40, width: 40 }
                        }} />)
                })
                const events = JSON.parse(JSON.stringify(this.state.filteredData.events.filter(d => d.coord)))
                events.sort((a, b) => {
                    if (moment(a.startTime).isAfter(moment(b.startTime))) return -1
                    if (moment(a.startTime).isBefore(moment(b.startTime))) return 1
                    return 0
                }).forEach((e, eidx) => {
                    let idx = this.state.filteredData.venues.findIndex(v => v.id === e.venue)
                    if (idx > -1) {
                        markers.push(<Marker onClick={() => this.handleEPinSelected({ ...this.state.filteredData.venues[idx] })} key={`epin-${eidx}`}
                            position={e.coord}
                            animation={2}
                            title={e.title}
                            icon={{
                                url: this.getEventMarker(e.summary || ''),
                                scaledSize: { height: 45, width: 45 }
                            }} />)
                    }
                })
            }
            if (this.state.hotels) {
                this.state.hotels.forEach((h, hidx) => {
                    markers.push(<Marker onClick={() => this.handleHPinSelected(h)} key={`hpin-${hidx}`}
                        position={h.coord}
                        animation={2}
                        title={h.name}
                        icon={{
                            url: Booking,
                            scaledSize: { height: 40, width: 40 }
                        }} />)
                })
            }
            if (this.state.rentals) {
                this.state.rentals.forEach((r, ridx) => {
                    markers.push(<Marker onClick={() => this.handleRPinSelected(r)} key={`rpin-${ridx}`}
                        position={r.coord}
                        animation={2}
                        title={r.name}
                        icon={{
                            url: ABNB,
                            scaledSize: { height: 40, width: 40 }
                        }} />)
                })
            }
            return markers
        } else return []
    }

    getLodgingCard() {
        return this.state.lodging ? <div className='Lodging-Container' style={{ background: `cadetblue${this.state.lodging.pic ? ` url(${this.state.lodging.pic}) no-repeat fixed center/cover` : ''}` }}>
            <div className="Lodging-Row Lodging-Top Lodging-Flex-Spread">
                <div className='Lodging-Text'>{this.state.lodging.ratingText || 'Unrated'}</div>
                <div className='Lodging-Stars'>
                    <FaStar />
                    <div className='Lodging-Stars-Text'>{this.state.lodging.rating ? this.state.lodging.rating.toFixed(1) : '0.0'}</div>
                </div>
            </div>
            <div className="Lodging-Row Lodging-Middle Lodging-Text">{this.state.lodging.name || 'Unnamed'}</div>
            <div className="Lodging-Row Lodging-Bottom Lodging-Text">{this.state.lodging.price ? `Estimated: $${this.state.lodging.price.toFixed(2)}` : 'No Price Estimate'}</div>
        </div> : null
    }

    getNoResults() {
        return <div className='Fan-NoMap-Container'>
            <div className='Fan-NoMap-Icon'><TbFilterSearch /></div>
            <div className='Fan-NoMap-Text'>No Matching Results</div>
            <div className='Fan-NoResults-Text'>Refine your search.</div>
        </div>
    }

    getIframe() {
        return <div className='Node-Iframe'>
            <div className='Node-Close-Outer'>
                <div className='Node-Close' onClick={() => this.handleIframeClick()}><FaRegWindowClose /></div>
            </div>
            <iframe src={this.state.src} title={this.state.title} width='100%' height='100%'></iframe>
        </div>
    }


    scrollToRef = ref => {
        if (ref.current) ref.current.scroll({
            top: 0,
            behavior: 'smooth'
        })
    }

    render() {
        //console.log(this.props.concierge)
        return <div className='Fan-Container'>
            {this.state.displayLink && this.getIframe()}

            <TopMenu
                mode='fan'
                onMode={this.handleModeChange}
                loc={this.state.loc}
                locIsGood={this.state.locIsGood}
                onLocCheck={this.handleLocationCheck}
                onLocChanged={this.handleLocChanged}
                dist={this.state.dist}
                onDistChange={this.handleDistChanged}
                onPref={this.handleOnPrefSelect}
                notifications={!this.props.concierge && this.props.user ? (this.props.user.notifications && this.props.user.notifications.length > 0 ? this.props.user.notifications.length : true) : null}
                onNotifications={this.handleOnNotificationsSelect}
                user={this.props.user ? { firstName: this.props.user.firstName, image: this.props.user.image, uid: this.props.user.id || null, premium: this.props.user.fanSubscription || null } : null}
                onSearch={this.handleDisplaySearch}
                onSettings={!this.props.concierge && this.handleDisplaySettings}
                options={this.state.options}
                month={this.state.month}
                days={this.state.days}
                onMonthChanged={this.handleMonthChanged}
                onMonthSelected={this.handleMonthSelected}
                onDaySelected={this.handleDayChanged}
                onOptionsSelected={this.handleOptionSelect}
                pref={this.state.pref}
                displaySearch={this.state.displaySearch}
                displaySettings={this.state.displaySettings}
                onResetOptions={this.handleResetOptions}
                search
                range
                calendar
                concierge={this.props.concierge}
                onGetMyLoc={this.handleGetMyLoc}
                lodging={!this.props.concierge && this.props.user && this.props.user.fanSubscription}
                onAbnb={this.handleAbnb}
                onHotels={this.handleHotels}
                hotel={this.state.hotel}
                abnb={this.state.abnb}
                hiring={this.props.hiring}
                onHiring={this.props.isAuthenticated ? this.handleHiring : null}
                card={this.props.user && this.props.user.card} />
            <div className='Fan-No-Scroll'>
                <div className={`Fan-Map-Container ${this.state.mapsize === 'full' ? 'Map-Full' : (this.state.mapsize === 'min' ? 'Map-Min' : 'Map-Half')}`}>
                    {
                        this.state.center ? <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
                            <GoogleMap
                                mapContainerStyle={{
                                    width: '100%',
                                    height: this.state.mapsize === 'full' ? 'calc(100vh - 325px)' : (this.state.mapsize === 'min' ? '0px' : 'calc(50vh - 195px)'),
                                    borderRadius: '5px'
                                }}
                                center={this.state.center}
                                zoom={this.state.zoom}>
                                <Marker
                                    position={this.props.myLoc}
                                    animation={1}
                                    title='GigIn from here.' />
                                {
                                    this.getMarkers()
                                }
                                {
                                    this.state.venue && this.state.mapsize === 'full' && <InfoWindow position={this.state.venue.address.coord} onCloseClick={() => this.handleCloseMarker()}>
                                        <div style={{ overflow: 'hidden' }} onClick={() => this.handleSmallSelected('venue')}><SmallCard data={this.state.venue} type='venue' /></div>
                                    </InfoWindow>
                                }
                                {
                                    this.state.event && this.state.mapsize === 'full' && <InfoWindow position={this.state.event.address.coord} onCloseClick={() => this.handleCloseMarker()}>
                                        <div style={{ overflow: 'hidden' }} onClick={() => this.handleSmallSelected('event')}><SmallCard data={this.state.event.events[0]} type='event' /></div>
                                    </InfoWindow>
                                }
                                {
                                    this.state.lodging && <InfoWindow position={this.state.lodging.coord} onCloseClick={() => this.handleCloseMarker()}>
                                        <div style={{ overflow: 'hidden' }} onClick={() => this.handleSmallSelected('hotel')}>{this.getLodgingCard()}</div>
                                    </InfoWindow>
                                }
                            </GoogleMap>
                        </LoadScript> : <div className='Fan-NoMap-Container'>
                            <div className='Fan-NoMap-Icon'><TbFilterSearch /></div>
                            <div className='Fan-NoMap-Text'>Set Your GigLocation!</div>
                            <div className='Fan-About' onClick={() => this.handleAbout()}>About Gigloca</div>
                        </div>
                    }
                </div>
                {this.state.center && <div className='Fan-Swipe-Container'>
                    <div className='Fan-HotTopics-Container'>
                        <div className={`Fan-HotTopics-Item${this.state.topic === 'restaurant' ? ' Fan-HotTopics-Venue' : ''}`} onClick={() => this.handleHotTopics('restaurant')}>
                            <MdDining />
                            <div className={`Fan-Hotipics-Text`}>Dining</div>
                        </div>
                        <div className={`Fan-HotTopics-Item${this.state.topic === 'bar' ? ' Fan-HotTopics-Venue' : ''}`} onClick={() => this.handleHotTopics('bar')}>
                            <CiBeerMugFull />
                            <div className='Fan-Hotipics-Text'>Bar</div>
                        </div>
                        <div className={`Fan-HotTopics-Item${this.state.topic === 'dj' ? ' Fan-HotTopics-Event' : ''}`} onClick={() => this.handleHotTopics('dj')}>
                            <FaRecordVinyl />
                            <div className='Fan-Hotipics-Text'>DJ</div>
                        </div>
                        <div className={`Fan-HotTopics-Item${this.state.topic === 'karaoke' ? ' Fan-HotTopics-Event' : ''}`} onClick={() => this.handleHotTopics('karaoke')}>
                            <GiMicrophone />
                            <div className='Fan-Hotipics-Text'>Karaoke</div>
                        </div>
                        <div className={`Fan-HotTopics-Item${this.state.topic === 'music' ? ' Fan-HotTopics-Event' : ''}`} onClick={() => this.handleHotTopics('music')}>
                            <GiGuitar />
                            <div className='Fan-Hotipics-Text'>Music</div>
                        </div>
                        <div className={`Fan-HotTopics-Item${this.state.topic === 'trivia' ? ' Fan-HotTopics-Event' : ''}`} onClick={() => this.handleHotTopics('trivia')}>
                            <MdOutlineQuestionAnswer />
                            <div className='Fan-Hotipics-Text'>Trivia</div>
                        </div>
                        <div className={`Fan-HotTopics-Item${this.state.topic === 'fire' ? ' Fan-HotTopics-Event' : ''}`} onClick={() => this.handleHotTopics('fire')}>
                            <BsFire />
                            <div className='Fan-Hotipics-Text'>Hot Topic</div>
                        </div>
                        <div className={`Fan-HotTopics-Item`} onClick={() => this.handleHotTopics(null)}>
                            <BiReset />
                            <div className='Fan-Hotipics-Text'>Reset</div>
                        </div>
                    </div>
                    <div className='Fan-Swipe-Bar-Row' onClick={() => this.handleSwipeClick()}>
                        <div className='Fan-Swipe-Flex'>
                            <div className='Fan-Swipe-Arrow'>{this.state.mapsize === 'half' ? <FaChevronDown /> : <FaChevronUp />}</div>
                            <div className='Fan-Swipe-Bar'></div>
                            <div className='Fan-Swipe-Arrow'>{this.state.mapsize === 'half' ? <FaChevronDown /> : <FaChevronUp />}</div>
                        </div>
                    </div>
                </div>}
                {
                    this.state.mapsize === 'half' && this.state.view === 'map' && <div ref={this.FanCards} className={`Fan-Cards`}>
                        {
                            !this.state.venue && !this.state.event && this.state.filteredData && this.state.filteredData.events && this.state.filteredData.events.sort((a, b) => {
                                //console.log('event', a)
                                let x = this.getDist(this.state.center, a.coord)
                                let y = this.getDist(this.state.center, b.coord)
                                if (x > y) return 1
                                if (x < y) return -1
                                return 0
                            }).map((e, eidx) => {
                                return <div key={`mwevent-${eidx}`} onClick={() => this.handleEventSelected(e.id)} style={{ cursor: 'pointer' }}><MiniWide type='event' data={e} near={this.props.user && this.props.user.dist && parseInt(this.props.user.dist) >= (e.distance || 0)} /></div>
                            })
                        }
                        {
                            !this.state.venue && !this.state.event && this.state.filteredData && this.state.filteredData.venues && this.state.filteredData.venues.sort((a, b) => {
                                let x = this.getDist(this.state.center, a.address.coord)
                                let y = this.getDist(this.state.center, b.address.coord)
                                if (x > y) return 1
                                if (x < y) return -1
                                return 0
                            }).map((v, vidx) => {
                                return <div key={`mwvenue-${vidx}`} onClick={() => this.handleVenueSelected(v)} style={{ cursor: 'pointer' }}><MiniWide type='venue' data={v} hiring={this.props.hiring} near={this.props.user && this.props.user.dist && parseInt(this.props.user.dist) >= (v.distance || 0)} /></div>
                            })
                        }
                        {
                            !this.state.venue && !this.state.event && this.state.next && <div className='Fan-More-Container' onClick={() => this.getData()}>
                                <div className='Fan-More-Divider'></div>
                                <div className='Fan-More-Button'>More</div>
                                <div className='Fan-More-Divider'></div>
                            </div>
                        }
                        {
                            this.state.event && this.state.event.events.sort((a, b) => {
                                if (a.startTime > b.startTime) return 1
                                if (a.startTime < b.startTime) return -1
                                return 0
                            }).map((e, eidx) => <div key={`ecard-${eidx}`} style={{ marginBottom: '10px' }}>
                                <Card data={{ ...this.state.event, events: [e] }} type='event' onSelected={this.handleGoToCard} onInterest={this.handleInterest} onAttending={this.handleAttending} near={this.props.user && this.props.user.dist && parseInt(this.props.user.dist) >= (this.state.event.distance || 0)} />
                            </div>)
                        }
                        {
                            this.state.venue && <Card data={this.state.venue} type='venue' onSelected={this.handleGoToCard} onFollow={this.handleFollow} hiring={this.props.hiring} near={this.props.user && this.props.user.dist && parseInt(this.props.user.dist) >= (this.state.venue.distance ? this.state.venue.distance : 0)} />
                        }
                        {
                            this.state.filteredData && ((this.state.filteredData.venues && this.state.filteredData.venues.length > 0) || (this.state.filteredData.events && this.state.filteredData.events.length > 0)) ? null : this.getNoResults()
                        }
                        {
                            this.state.displayMsg && this.getMessage()
                        }
                    </div>
                }
            </div>
            <BottomMenu menu={this.state.menu} onLeft={this.handleLeftMenu} onGiglit={this.handleGiglit} onRight={this.handleRightMenu} concierge={this.props.concierge || false} />
        </div>
    }
}

export default withRouter(Fan)